import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';

const styles = css``;

function NoRoute({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto py-5">
            <h3>{get(page, 'lead_copy')}</h3>
            <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

NoRoute.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: '404_page',
})(NoRoute);



// WEBPACK FOOTER //
// ./src/pages/NoRoute/index.js